import { AppDeployment } from '@atlassian/mpac-types';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';

// The original app deployment type does not have a `__typename` field as
// it's an interface, but the concrete types that implement it will.

/**
 * Apps types that are informational listings, and not backed by app assets.
 * Corresponds to plugin system version of `none` in the data model
 */
export function isNotAnApp(appDeployment) {
  return [AppDeployment.INSTRUCTIONAL, AppDeployment.WORKFLOW].includes(appDeployment.__typename);
}

/**
 * Apps deployment types that hosted remotely.
 */
export function isRemoteable(appDeployment) {
  return [AppDeployment.CONNECT, AppDeployment.ECOSYSTEM_CLOUD].includes(appDeployment.__typename);
}

/**
 * Apps that don't officially have a DC version, but might be DC compatible
 */
export function
// TODO verify if default value needs to be passed.
maybeDCCompatible() {
  let productHostingOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let serverCompatibleProducts = arguments.length > 1 ? arguments[1] : undefined;
  const isDCCompatible = productHostingOptions.includes(AtlassianProductHostingType.DataCenter);
  const isServerCompatible = productHostingOptions.includes(AtlassianProductHostingType.Server);
  const isCompatibleWithSomeDCEnabledProduct = serverCompatibleProducts.some(compatibleProduct => {
    var _compatibleProduct$at;
    return (_compatibleProduct$at = compatibleProduct.atlassianProduct) === null || _compatibleProduct$at === void 0 ? void 0 : _compatibleProduct$at.hostingOptions.includes(AtlassianProductHostingType.DataCenter);
  });
  return !isDCCompatible && isServerCompatible && isCompatibleWithSomeDCEnabledProduct;
}

/**
 * While server apps are usually perpetually licensed, there are
 * some special cases that require annual renewals.
 * @see ecosystem.atlassian.net/browse/AMKT-22169
 */
export function isServerSubscriptionApp(appKey) {
  return ['atlassian-jira-training'].includes(appKey);
}

/**
 * Translate marketplace app keys to legacy HAMS keys
 * understood by commerce systems
 */

export function toHAMSAppKey(appKey, hosting) {
  if (hosting === AtlassianProductHostingType.DataCenter) {
    return "".concat(appKey, ".data-center");
  }
  if (hosting === AtlassianProductHostingType.Cloud) {
    return "".concat(appKey, ".ondemand");
  }
  return appKey;
}
const FECRU = 'fecru';
const BAMBOO = 'bamboo';
const CROWD = 'crowd';
const getServerEolStartDate = compatibleProducts => {
  for (const product of compatibleProducts) {
    switch (product.id) {
      case BAMBOO:
      case CROWD:
        return 'November 19, 2023';
      case FECRU:
        return 'May 13, 2025';
    }
  }
  return 'Feb 15, 2023';
};

/**
 * Checks if app's selected hosting is `server` and returns boolean flags for
 * showing installation tab and server end of life warning message
 * by further checking if the selected server app's parent product is not in
 * Fisheye/Crucible and also if parent product is not in bamboo and crowd on the basis of feature flag.
 * @param isServerApp boolean
 * @param compatibleProducts AppListingAppDeployment_MarketplacePlugins2AppDeployment_Fragment
 * @param featureFlags FeatureFlags
 * @returns showInstallationTab: boolean; showServerEolWarning: boolean; serverEolStartDate: string
 */
export const isServerAppEol = (isServerApp, compatibleProducts) => {
  if (isServerApp) {
    const serverEolStartDate = getServerEolStartDate(compatibleProducts);
    return {
      showInstallationTab: false,
      showServerEolWarning: true,
      serverEolStartDate
    };
  }
  return {
    showInstallationTab: true,
    showServerEolWarning: false,
    serverEolStartDate: ''
  };
};